module.exports = {
	"1": {
		"name": "Australia",
		"mask": "+61",
		"length": 9
	},
	"2": {
		"name": "Austria",
		"mask": "+43",
		"length": 9
	},
	"3": {
		"name": "Azerbaijan",
		"mask": "+994",
		"length": 9
	},
	"5": {
		"name": "Algeria",
		"mask": "+213",
		"length": 9
	},
	"6": {
		"name": "American Samoa",
		"mask": "+1",
		"length": 10
	},
	"7": {
		"name": "Anguilla",
		"mask": "+1",
		"length": 10
	},
	"8": {
		"name": "Angola",
		"mask": "+244",
		"length": 9
	},
	"9": {
		"name": "Andorra",
		"mask": "+376",
		"length": 6
	},
	"11": {
		"name": "Antigua And Barbuda",
		"mask": "+1",
		"length": 10
	},
	"12": {
		"name": "Argentina",
		"mask": "+54",
		"length": 11
	},
	"13": {
		"name": "Armenia",
		"mask": "+374",
		"length": 8
	},
	"14": {
		"name": "Aruba",
		"mask": "+297",
		"length": 7
	},
	"15": {
		"name": "Afghanistan",
		"mask": "+93",
		"length": 9
	},
	"16": {
		"name": "Bahamas",
		"mask": "+1",
		"length": 10
	},
	"17": {
		"name": "Bangladesh",
		"mask": "+880",
		"length": 10
	},
	"18": {
		"name": "Barbados",
		"mask": "+1",
		"length": 10
	},
	"19": {
		"name": "Bahrain",
		"mask": "+973",
		"length": 8
	},
	"20": {
		"name": "Belize",
		"mask": "+501",
		"length": 7
	},
	"21": {
		"name": "Belarus",
		"mask": "+375",
		"length": 9
	},
	"22": {
		"name": "Belgium",
		"mask": "+32",
		"length": 9
	},
	"23": {
		"name": "Benin",
		"mask": "+229",
		"length": 8
	},
	"24": {
		"name": "Bermuda",
		"mask": "+1",
		"length": 10
	},
	"25": {
		"name": "Bulgaria",
		"mask": "+359",
		"length": 8
	},
	"26": {
		"name": "Bolivia",
		"mask": "+571",
		"length": 8
	},
	"27": {
		"name": "Bosnia And Herzegovina",
		"mask": "+387",
		"length": 8
	},
	"28": {
		"name": "Botswana",
		"mask": "+267",
		"length": 8
	},
	"29": {
		"name": "Brazil",
		"mask": "+55",
		"length": 10
	},
	"30": {
		"name": "British Indian Ocean Territory",
		"mask": "+246",
		"length": 7
	},
	"32": {
		"name": "Brunei Darussalam",
		"mask": "+673",
		"length": 7
	},
	"33": {
		"name": "Burkina Faso",
		"mask": "+226",
		"length": 8
	},
	"34": {
		"name": "Burundi",
		"mask": "+257",
		"length": 8
	},
	"35": {
		"name": "Bhutan",
		"mask": "+975",
		"length": 8
	},
	"36": {
		"name": "Vanuatu",
		"mask": "+678",
		"length": 7
	},
	"38": {
		"name": "United Kingdom",
		"mask": "+44",
		"length": 10
	},
	"39": {
		"name": "Hungary",
		"mask": "+36",
		"length": 9
	},
	"40": {
		"name": "Venezuela",
		"mask": "+58",
		"length": 10
	},
	"42": {
		"name": "Vietnam",
		"mask": "+84",
		"length": 9
	},
	"43": {
		"name": "Gabon",
		"mask": "+241",
		"length": 8
	},
	"44": {
		"name": "Haiti",
		"mask": "+509",
		"length": 8
	},
	"45": {
		"name": "Guyana",
		"mask": "+592",
		"length": 7
	},
	"46": {
		"name": "Gambia",
		"mask": "+220",
		"length": 7
	},
	"47": {
		"name": "Ghana",
		"mask": "+233",
		"length": 9
	},
	"48": {
		"name": "Guadeloupe",
		"mask": "+590",
		"length": 9
	},
	"49": {
		"name": "Guatemala",
		"mask": "+502",
		"length": 8
	},
	"50": {
		"name": "Guinea",
		"mask": "+224",
		"length": 8
	},
	"51": {
		"name": "Guinea-Bissau",
		"mask": "+245",
		"length": 7
	},
	"52": {
		"name": "Germany",
		"mask": "+49",
		"length": 11
	},
	"53": {
		"name": "Honduras",
		"mask": "+504",
		"length": 8
	},
	"54": {
		"name": "State of Palestine",
		"mask": "+970",
		"length": 9
	},
	"55": {
		"name": "Grenada",
		"mask": "+1",
		"length": 10
	},
	"56": {
		"name": "Greenland",
		"mask": "+299",
		"length": 6
	},
	"58": {
		"name": "Guam",
		"mask": "+1",
		"length": 10
	},
	"60": {
		"name": "Djibouti",
		"mask": "+253",
		"length": 8
	},
	"61": {
		"name": "Dominica",
		"mask": "+1",
		"length": 10
	},
	"62": {
		"name": "Dominican Republic",
		"mask": "+1",
		"length": 10
	},
	"63": {
		"name": "Egypt",
		"mask": "+20",
		"length": 10
	},
	"64": {
		"name": "Zambia",
		"mask": "+260",
		"length": 9
	},
	"65": {
		"name": "Western Sahara",
		"mask": "+212",
		"length": 9
	},
	"66": {
		"name": "Zimbabwe",
		"mask": "+263",
		"length": 9
	},
	"67": {
		"name": "Israel",
		"mask": "+972",
		"length": 9
	},
	"68": {
		"name": "India",
		"mask": "+91",
		"length": 10
	},
	"69": {
		"name": "Indonesia",
		"mask": "+62",
		"length": 9
	},
	"70": {
		"name": "Jordan",
		"mask": "+962",
		"length": 9
	},
	"71": {
		"name": "Iraq",
		"mask": "+964",
		"length": 10
	},
	"72": {
		"name": "Iran, Islamic Republic of",
		"mask": "+98",
		"length": 10
	},
	"73": {
		"name": "Ireland",
		"mask": "+353",
		"length": 9
	},
	"74": {
		"name": "Iceland",
		"mask": "+354",
		"length": 7
	},
	"75": {
		"name": "Spain",
		"mask": "+34",
		"length": 9
	},
	"76": {
		"name": "Italy",
		"mask": "+39",
		"length": 10
	},
	"77": {
		"name": "Yemen",
		"mask": "+967",
		"length": 9
	},
	"78": {
		"name": "Cape Verde",
		"mask": "+238",
		"length": 7
	},
	"79": {
		"name": "Kazakstan",
		"mask": "+7",
		"length": 10
	},
	"80": {
		"name": "Cayman Islands",
		"mask": "+1",
		"length": 10
	},
	"81": {
		"name": "Cambodia",
		"mask": "+855",
		"length": 8
	},
	"82": {
		"name": "Cameroon",
		"mask": "+237",
		"length": 8
	},
	"83": {
		"name": "Canada",
		"mask": "+1",
		"length": 10
	},
	"84": {
		"name": "Qatar",
		"mask": "+974",
		"length": 8
	},
	"85": {
		"name": "Kenya",
		"mask": "+254",
		"length": 9
	},
	"86": {
		"name": "Kiribati",
		"mask": "+686",
		"length": 5
	},
	"87": {
		"name": "Taiwan, Province of China",
		"mask": "+886",
		"length": 9
	},
	"88": {
		"name": "Korea, Democratic People's Republic of",
		"mask": "+850",
		"length": 10
	},
	"89": {
		"name": "Cocos (Keeling) Islands",
		"mask": "+61",
		"length": 9
	},
	"90": {
		"name": "Colombia",
		"mask": "+57",
		"length": 10
	},
	"91": {
		"name": "Comoros",
		"mask": "+269",
		"length": 7
	},
	"92": {
		"name": "Costa Rica",
		"mask": "+506",
		"length": 8
	},
	"93": {
		"name": "Cote D'Ivoire",
		"mask": "+255",
		"length": 8
	},
	"94": {
		"name": "Cuba",
		"mask": "+53",
		"length": 8
	},
	"95": {
		"name": "Kuwait",
		"mask": "+965",
		"length": 7
	},
	"96": {
		"name": "Kyrgyzstan",
		"mask": "+996",
		"length": 9
	},
	"97": {
		"name": "Lao People's Democratic Republic",
		"mask": "+856",
		"length": 10
	},
	"98": {
		"name": "Lesotho",
		"mask": "+266",
		"length": 8
	},
	"99": {
		"name": "Liberia",
		"mask": "+231",
		"length": 7
	},
	"100": {
		"name": "Lebanon",
		"mask": "+961",
		"length": 8
	},
	"101": {
		"name": "Libyan Arab Jamahiriya",
		"mask": "+218",
		"length": 9
	},
	"102": {
		"name": "Lithuania",
		"mask": "+218",
		"length": 9
	},
	"103": {
		"name": "Luxembourg",
		"mask": "+352",
		"length": 9
	},
	"104": {
		"name": "Mauritius",
		"mask": "+230",
		"length": 7
	},
	"105": {
		"name": "Mauritania",
		"mask": "+222",
		"length": 8
	},
	"106": {
		"name": "Madagascar",
		"mask": "+261",
		"length": 9
	},
	"107": {
		"name": "Mayotte",
		"mask": "+262",
		"length": 9
	},
	"108": {
		"name": "Malawi",
		"mask": "+265",
		"length": 9
	},
	"109": {
		"name": "Malaysia",
		"mask": "+60",
		"length": 9
	},
	"110": {
		"name": "Mali",
		"mask": "+223",
		"length": 8
	},
	"111": {
		"name": "Maldives",
		"mask": "+960",
		"length": 7
	},
	"112": {
		"name": "Malta",
		"mask": "+356",
		"length": 8
	},
	"113": {
		"name": "Morocco",
		"mask": "+212",
		"length": 9
	},
	"114": {
		"name": "Marshall Islands",
		"mask": "+692",
		"length": 7
	},
	"115": {
		"name": "Mexico",
		"mask": "+52",
		"length": 11
	},
	"116": {
		"name": "Micronesia, Federated States of",
		"mask": "+691",
		"length": 7
	},
	"117": {
		"name": "Mozambique",
		"mask": "+258",
		"length": 9
	},
	"118": {
		"name": "Moldova, Republic of",
		"mask": "+373",
		"length": 8
	},
	"119": {
		"name": "Monaco",
		"mask": "+377",
		"length": 9
	},
	"120": {
		"name": "Mongolia",
		"mask": "+976",
		"length": 8
	},
	"121": {
		"name": "Montserrat",
		"mask": "+1",
		"length": 10
	},
	"122": {
		"name": "Myanmar",
		"mask": "+95",
		"length": 8
	},
	"123": {
		"name": "Namibia",
		"mask": "+264",
		"length": 9
	},
	"124": {
		"name": "Nauru",
		"mask": "+674",
		"length": 7
	},
	"125": {
		"name": "Nepal",
		"mask": "+977",
		"length": 10
	},
	"126": {
		"name": "Niger",
		"mask": "+227",
		"length": 8
	},
	"127": {
		"name": "Nigeria",
		"mask": "+234",
		"length": 10
	},
	"129": {
		"name": "Netherlands",
		"mask": "+31",
		"length": 9
	},
	"130": {
		"name": "Nicaragua",
		"mask": "+505",
		"length": 8
	},
	"131": {
		"name": "Niue",
		"mask": "+683",
		"length": 4
	},
	"132": {
		"name": "New Zealand",
		"mask": "+64",
		"length": 9
	},
	"133": {
		"name": "New Caledonia",
		"mask": "+687",
		"length": 6
	},
	"134": {
		"name": "Norway",
		"mask": "+47",
		"length": 8
	},
	"135": {
		"name": "United Arab Emirates",
		"mask": "+971",
		"length": 9
	},
	"136": {
		"name": "Oman",
		"mask": "+968",
		"length": 8
	},
	"138": {
		"name": "Norfolk Island",
		"mask": "+672",
		"length": 6
	},
	"139": {
		"name": "Christmas Island",
		"mask": "+61",
		"length": 9
	},
	"141": {
		"name": "Cook Islands",
		"mask": "+682",
		"length": 5
	},
	"143": {
		"name": "Pakistan",
		"mask": "+92",
		"length": 10
	},
	"144": {
		"name": "Palau",
		"mask": "+680",
		"length": 7
	},
	"145": {
		"name": "Papua New Guinea",
		"mask": "+675",
		"length": 7
	},
	"146": {
		"name": "Paraguay",
		"mask": "+595",
		"length": 9
	},
	"147": {
		"name": "Peru",
		"mask": "+51",
		"length": 9
	},
	"148": {
		"name": "Poland",
		"mask": "+48",
		"length": 9
	},
	"149": {
		"name": "Portugal",
		"mask": "+351",
		"length": 9
	},
	"150": {
		"name": "Puerto Rico",
		"mask": "+1",
		"length": 10
	},
	"151": {
		"name": "Congo",
		"mask": "+243",
		"length": 9
	},
	"152": {
		"name": "Korea, Republic of",
		"mask": "+82",
		"length": 10
	},
	"153": {
		"name": "Macedonia, The Former Yugoslav Republic of",
		"mask": "+389",
		"length": 8
	},
	"154": {
		"name": "Russian Federation",
		"mask": "+7",
		"length": 10
	},
	"155": {
		"name": "Rwanda",
		"mask": "+250",
		"length": 9
	},
	"156": {
		"name": "Romania",
		"mask": "+40",
		"length": 9
	},
	"157": {
		"name": "El Salvador",
		"mask": "+503",
		"length": 8
	},
	"158": {
		"name": "Samoa",
		"mask": "+685",
		"length": 6
	},
	"159": {
		"name": "San Marino",
		"mask": "+378",
		"length": 8
	},
	"160": {
		"name": "Sao Tome And Principe",
		"mask": "+239",
		"length": 7
	},
	"161": {
		"name": "Saudi Arabia",
		"mask": "+966",
		"length": 9
	},
	"162": {
		"name": "Swaziland",
		"mask": "+268",
		"length": 8
	},
	"163": {
		"name": "Northern Mariana Islands",
		"mask": "+1",
		"length": 10
	},
	"164": {
		"name": "Seychelles",
		"mask": "+248",
		"length": 7
	},
	"165": {
		"name": "Saint Pierre And Miquelon",
		"mask": "+508",
		"length": 6
	},
	"166": {
		"name": "Senegal",
		"mask": "+221",
		"length": 9
	},
	"167": {
		"name": "Saint Vincent And The Grenadines",
		"mask": "+1",
		"length": 10
	},
	"168": {
		"name": "Saint Kitts And Nevis",
		"mask": "+1",
		"length": 10
	},
	"169": {
		"name": "Saint Lucia",
		"mask": "+1",
		"length": 10
	},
	"170": {
		"name": "Serbia",
		"mask": "+381",
		"length": 9
	},
	"171": {
		"name": "Singapore",
		"mask": "+65",
		"length": 8
	},
	"172": {
		"name": "Syrian Arab Republic",
		"mask": "+963",
		"length": 9
	},
	"173": {
		"name": "Slovakia (Slovak Republic)",
		"mask": "+421",
		"length": 9
	},
	"174": {
		"name": "Slovenia",
		"mask": "+386",
		"length": 8
	},
	"175": {
		"name": "Solomon Islands",
		"mask": "+677",
		"length": 7
	},
	"176": {
		"name": "Somalia",
		"mask": "+252",
		"length": 8
	},
	"177": {
		"name": "Sudan",
		"mask": "+249",
		"length": 9
	},
	"178": {
		"name": "Suriname",
		"mask": "+597",
		"length": 7
	},
	"179": {
		"name": "Sierra Leone",
		"mask": "+232",
		"length": 8
	},
	"180": {
		"name": "Tajikistan",
		"mask": "+992",
		"length": 9
	},
	"181": {
		"name": "Thailand",
		"mask": "+66",
		"length": 9
	},
	"182": {
		"name": "Tanzania, United Republic of",
		"mask": "+255",
		"length": 9
	},
	"183": {
		"name": "Turks And Caicos Islands",
		"mask": "+1",
		"length": 10
	},
	"184": {
		"name": "Togo",
		"mask": "+228",
		"length": 8
	},
	"185": {
		"name": "Tokelau",
		"mask": "+676",
		"length": 7
	},
	"186": {
		"name": "Tonga",
		"mask": "+676",
		"length": 7
	},
	"187": {
		"name": "Trinidad And Tobago",
		"mask": "+1",
		"length": 10
	},
	"188": {
		"name": "Tuvalu",
		"mask": "+688",
		"length": 6
	},
	"189": {
		"name": "Tunisia",
		"mask": "+216",
		"length": 8
	},
	"190": {
		"name": "Turkmenistan",
		"mask": "+993",
		"length": 8
	},
	"191": {
		"name": "Uganda",
		"mask": "+256",
		"length": 9
	},
	"192": {
		"name": "Uzbekistan",
		"mask": "+998",
		"length": 9
	},
	"193": {
		"name": "Ukraine",
		"mask": "+380",
		"length": 9
	},
	"194": {
		"name": "Wallis And Futuna Islands",
		"mask": "+681",
		"length": 6
	},
	"195": {
		"name": "Uruguay",
		"mask": "+598",
		"length": 8
	},
	"196": {
		"name": "Faroe Islands",
		"mask": "+298",
		"length": 6
	},
	"197": {
		"name": "Fiji",
		"mask": "+679",
		"length": 7
	},
	"198": {
		"name": "Philippines",
		"mask": "+63",
		"length": 10
	},
	"199": {
		"name": "Finland",
		"mask": "+358",
		"length": 9
	},
	"200": {
		"name": "Falkland Islands (Malvinas)",
		"mask": "+500",
		"length": 5
	},
	"201": {
		"name": "French Polynesia",
		"mask": "+689",
		"length": 9
	},
	"203": {
		"name": "Central African Republic",
		"mask": "+236",
		"length": 8
	},
	"204": {
		"name": "Chad",
		"mask": "+235",
		"length": 8
	},
	"205": {
		"name": "Montenegro",
		"mask": "+382",
		"length": 8
	},
	"206": {
		"name": "Czech Republic",
		"mask": "+420",
		"length": 9
	},
	"207": {
		"name": "Chile",
		"mask": "+56",
		"length": 9
	},
	"208": {
		"name": "Sweden",
		"mask": "+46",
		"length": 9
	},
	"209": {
		"name": "Svalbard And Jan Mayen Islands",
		"mask": "+47",
		"length": 8
	},
	"210": {
		"name": "Sri Lanka",
		"mask": "+94",
		"length": 9
	},
	"211": {
		"name": "Ecuador",
		"mask": "+593",
		"length": 9
	},
	"212": {
		"name": "Equatorial Guinea",
		"mask": "+240",
		"length": 9
	},
	"213": {
		"name": "Eritrea",
		"mask": "+291",
		"length": 7
	},
	"214": {
		"name": "Estonia",
		"mask": "+372",
		"length": 8
	},
	"216": {
		"name": "South Africa",
		"mask": "+27",
		"length": 9
	},
	"218": {
		"name": "Jamaica",
		"mask": "+1",
		"length": 10
	},
	"219": {
		"name": "Japan",
		"mask": "+81",
		"length": 10
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/availableCountries/en.json
// module id = 649
// module chunks = 2 3